import request from '@/utils/request'

/**
 * 上传文件
 * @param {Object} data 上传文件数据
 * @returns {Promise} 返回上传结果
 */
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload/uploadFile',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}